import { createStore } from "vuex";
import { leftMenuConfigOptions } from "@/config/platformConfig";

export default createStore({
    state: {
        menuListAll: [],
        pathObject: {},
        authList: [],
        authRouterList: [],
        singleVueLoading: false,
        tabsView: {},
        TechnologieTypeId: {
            classification: null,
            projectId: null,
        }//科技项目申报
    },
    getters: {
        menuListAll(state) {
            return state.menuListAll || [];
        },
        pathObject(state) {
            return state.pathObject || {};
        },
        authList(state) {
            return state.authList || [];
        },
        authRouterList(state) {
            return state.authRouterList || [];
        },
        tabsView(state) {
            return state.tabsView || {};
        },
        TechnologieTypeId(state) {
            return state.TechnologieTypeId || {};
        }
    },
    mutations: {
        setMenuList(state, list) {
            state.menuListAll = list.filter((v) => {
                return v.type === "menu";
            });
        },
        setPathObject(state, list) {
            let pathObject = {};
            list.forEach((v) => {
                pathObject[v[leftMenuConfigOptions.keyField]] =
                    v[leftMenuConfigOptions.pathField];
            });
            state.pathObject = pathObject;
        },
        setMenuData(state, list) {
            if (!list || !list.length) {
                return;
            }
            let pathObject = {};
            let authObj = {};
            let authRouterList = new Set(["/desktop", "/search", "/e-403"]);

            list.forEach((v) => {
                pathObject[v[leftMenuConfigOptions.keyField]] =
                    v[leftMenuConfigOptions.pathField];

                authObj[v.menuCode] = v.identifier;

                let path = v[leftMenuConfigOptions.pathField] || null;
                if (path && path !== "javascript:;") {
                    authRouterList.add(path);
                }
            });

            state.menuListAll = list.filter((v) => v.type === "menu");
            state.pathObject = pathObject;
            state.authList = Object.keys(authObj);
            state.authRouterList = Array.from(authRouterList);
        },
        setSingleVueLoading(state, bool) {
            state.singleVueLoading = bool;
        },
        setTabsView(state, tabsView) {
            state.tabsView = tabsView;
        },
        setTabsViewPage(state, page) {
            state.tabsView.pageList = [
                ...(state.tabsView.pageList || []),
                page,
            ];
        },
        
        TechnologieTypeId(state, TechnologieTypeId) {
            state.TechnologieTypeId = TechnologieTypeId
        },

        removeViewPage(state, key) {
            console.log(state);
            for (var i = 0; i < 10; i++) {
                if (state.tabsView.pageList[i].path === key) {
                    // TODO 查找删除
                    state.tabsView.pageList = state.tabsView.pageList.splice(i,1);
                } else {
                    console.log("getout");
                }
            }
        },
        setTabsViewActive(state, active) {
            state.tabsView.active = active;
        },
    },
    actions: {},
    modules: {},
});
